<div class="d-flex align-items-center justify-content-between gap-8 w-100">
  @for (chunk of navigationChunks(); track chunk.date) {
    <div class="note-nav-item" [class.trigger]="$index !== 1">
      @if ($index !== 1) {
        <button
          (click)="service.currentDate.set(chunk.date)"
          [class.left]="$index === 0"
          [class.right]="$index === 2"
          class="btn d-flex align-items-center justify-content-between">
          @if ($index == 0) {
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          }
          @if (chunk.isToday) {
            <div>{{ 'Today' | appTranslate | async }}</div>
          } @else {
            {{ chunk.date | date: 'dd MMM' | appTranslate | async }}
          }
          @if ($index == 2) {
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          }
        </button>
      } @else {
        <div class="note-nav-item-title">
          @if (chunk.isToday) {
            <div>{{ 'Today' | appTranslate | async }}</div>
          }
          <div>
            {{ chunk.date | date: 'dd MMM' | appTranslate | async }}
          </div>
        </div>
      }
    </div>
  }
</div>
<div class="d-flex glass event-type-filter">
  @for (type of service.types(); track type.value) {
    <button
      class="btn  {{ eventTypeFilter() == type.value ? 'btn-primary' : 'btn-outline-primary' }}"
      [style.color]="service.typeToColour[type.value]"
      (click)="eventTypeFilter.set(type.value)">
      {{ type.label | titlecase | appTranslate | async }}
    </button>
  }
</div>
<div class="d-flex flex-column h-100 gap-8 overflow-auto middle-cont">
  @if (loading()) {
    <loader [loading]="true" class="vh-10" />
  } @else {
    <mat-list class="gap-1 d-flex flex-column">
      @for (note of notes(); track note.id) {
        <mat-list-item class="px-0 pointer" [matMenuTriggerFor]="viewMenu" #viewMenuTrigger="matMenuTrigger">
          <div
            class="note-item d-flex align-items-center {{ note.eventType }} "
            [class.past]="note._eventOnTimestamp < now">
            <span class="event-time">
              @for (time of note.eventOn | date: 'hh:mm a' | splitTime; track time) {
                <div>{{ time }}</div>
              }
            </span>
            <span class="event-divider" [style.backgroundColor]="service.typeToColour[note.eventType]"></span>
            <div class="main-cont">
              <div class="event-title">{{ note.title }}</div>
              <div class="event-type">{{ note.eventType | appTranslate | async }}</div>
            </div>
            <!-- <div class="event-actions">
              <app-btn
                type="clear"
                customIcon="fa fa-expand"
                mainClass="text-light"
                [mini]="true"
                (mclick)="currentNote.set(note); viewMenuTrigger.closeMenu(); viewNoteModal.open()" />
              <app-btn
                type="clear"
                customIcon="fa fa-close"
                mainClass="text-light"
                [mini]="true"
                (mclick)="viewMenuTrigger.closeMenu()" />
            </div> -->
          </div>
          <mat-menu #viewMenu="matMenu" class="">
            <ng-template matMenuContent>
              <div (click)="$event.stopPropagation()">
                <view-user-calendar-note
                  [note]="note"
                  [mini]="true"
                  (done)="viewMenuTrigger.closeMenu()"
                  (expand)="currentNote.set(note); viewMenuTrigger.closeMenu(); viewNoteModal.open()" />
              </div>
            </ng-template>
          </mat-menu>
        </mat-list-item>
      } @empty {
        <mat-list-item>
          {{ 'You have no notes' | appTranslate | async }}
        </mat-list-item>
      }
    </mat-list>
  }
</div>
<div class="mt-16 glass d-flex rounded-10 align-items-center toolbar justify-content-end">
  @if (showTodayBtn()) {
    <button (click)="service.currentDate.set(service.today())" class="btn btn-outline-primary">
      <i class="fa fa-map-pin" aria-hidden="true"></i>
      <span>{{ 'Today' | appTranslate | async }}</span>
    </button>
  }
  <!-- @if (service.canAddNote()) { -->
  <button (click)="addNoteModal.open()" class="btn btn-outline-primary">
    <i class="fa fa-edit" aria-hidden="true"></i>
    <span>{{ 'Add Note' | appTranslate | async }}</span>
  </button>
  <!-- } -->
  <button (click)="calendarModal.open()" class="btn btn-outline-primary">
    <i class="fa fa-calendar" aria-hidden="true"></i>
    <span>{{ 'Calendar' | appTranslate | async }}</span>
  </button>
  <div class="d-none">
    <modal-comp #calendarModal header="Calendar" [showFooter]="false" width="800px" height="auto">
      <ng-template modalBody>
        <user-calendar [selectedEvent]="currentNote()" />
      </ng-template>
    </modal-comp>
    <modal-comp #addNoteModal header="Add Note" [showFooter]="false" width="500px" height="auto">
      <ng-template modalBody>
        <save-user-calendar-note
          [note]="currentNote()"
          (done)="addNoteModal.close(); currentNote.set(null);service.currentDateNotesRes.reload()" />
      </ng-template>
    </modal-comp>
    <modal-comp #viewNoteModal header="Note" [showFooter]="false" width="500px" height="auto">
      <ng-template modalBody>
        <view-user-calendar-note
          [note]="currentNote()"
          (done)="viewNoteModal.close(); currentNote.set(null)" />
      </ng-template>
    </modal-comp>
  </div>
</div>
